import { __assign, __makeTemplateObject, __rest } from "tslib";
import React, { forwardRef } from 'react';
import clsx from 'clsx';
import { DragableArea as DraggableHandle } from '@ringcentral/juno-icon';
import { styled, useThemeProps } from '../../../foundation';
import { RcIcon } from '../../Icon';
import { dragHandleStyle } from './styles';
import { RcDragHandleClasses } from './utils';
var defaultChildren = React.createElement(RcIcon, { size: "xsmall", symbol: DraggableHandle });
var _DragHandle = forwardRef(function (inProps, ref) {
    var props = useThemeProps({ props: inProps, name: 'RcDragHandle' });
    var _a = props.children, children = _a === void 0 ? defaultChildren : _a, className = props.className, rest = __rest(props, ["children", "className"]);
    var ClassName = clsx(RcDragHandleClasses.root, className);
    return (React.createElement("div", __assign({}, rest, { className: ClassName, ref: ref }), children));
});
var RcDragHandle = styled(_DragHandle)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), dragHandleStyle);
RcDragHandle.defaultProps = {};
RcDragHandle.displayName = 'RcDragHandle';
export { RcDragHandle };
var templateObject_1;
